import { render, staticRenderFns } from "./TasksColumn.vue?vue&type=template&id=a9b7cb6e&scoped=true&"
import script from "./TasksColumn.vue?vue&type=script&lang=js&"
export * from "./TasksColumn.vue?vue&type=script&lang=js&"
import style0 from "./TasksColumn.vue?vue&type=style&index=0&id=a9b7cb6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b7cb6e",
  null
  
)

/* custom blocks */
import block0 from "./TasksColumn.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports